import { createWebHistory, createRouter } from 'vue-router';
import { authGuard } from './auth-guard';

const routes = [
	{ path: '/:catchAll(.*)', redirect: { name: 'Login' } },
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/components/authentication/Layout.vue')
	}, {
		path: '/admin',
		name: 'PageLayout',
		beforeEnter: authGuard,
		component: () => import('@/components/authentication/PageLayout.vue'),
		children: [
			{
				path: '/dashboard',
				name: 'Dashboard',
				component: () => import('@/components/Pages/dashboard.vue')
			},
			{
				path: '/interfaces',
				name: 'Interfaces',
				component: () => import('@/components/Pages/interface.vue')
			},
			{
				path: '/tools',
				name: 'Tools',
				component: () => import('@/components/Pages/tools.vue')
			},
			{
				path: '/monitoring',
				name: 'Monitoring',
				component: () => import('@/components/Pages/monitoring.vue')
			},
			{
				path: '/bandwidth',
				name: 'Bandwidth',
				component: () => import('@/components/Pages/bandwidth.vue')
			},
			{
				path: '/speed',
				name: 'Speed',
				component: () => import('@/components/Pages/speed.vue')
			},
			{
				path: '/metrics',
				name: 'Metrics',
				component: () => import('@/components/Pages/metrics.vue')
			},
			{
				path: '/settings',
				name: 'Settings',
				component: () => import('@/components/Pages/settings.vue')
			},
			{
				path: '/logout',
				name: 'Logout',
				component: () => import('@/components/authentication/Logout.vue')
			},
		]
	}
];

const router = createRouter({
	history: createWebHistory(),
	hash: false,
	routes,
});

export default router;